import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { Overrides } from '@material-ui/core/styles/overrides';

import variables from './variables';

const defaultTheme = createMuiTheme();

const overrides: Overrides = {
  MuiDrawer: {
    paper: {
      backgroundColor: variables.colors['drawerBackground']
    }
  },
  MuiInput: {
    root: {
      borderRadius: 4,
      backgroundColor: defaultTheme.palette.common.white,
      border: '1px solid #ced4da',
      fontSize: 14,
      padding: '7px 10px',
      transition: defaultTheme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
      },
      '&:before': {
        display: 'none'
      }
    }
  },
  MuiTypography: {
    title: {
      color: variables.colors['title'],
      fontFamily: 'Lato',
      fontSize: 18,
      fontWeight: 'bold'
    },
    subheading: {
      color: variables.colors['title'],
      fontFamily: 'Lato',
      fontSize: 15,
      fontWeight: 'bold'
    },
    body2: {
      color: variables.colors['text'],
      fontFamily: 'Lato',
      lineHeight: 1.35
    }
  },
  MuiTableRow: {
    root: {
      height: 35
    }
  },
  MuiTableCell: {
    root: {
      padding: '3px 0 3px 0',
      fontFamily: 'Lato',
      '&:last-child': {
        paddingRight: 0
      }
    },
    body: {
      fontSize: 14
    }
  },
  MuiTablePagination: {
    input: {
      padding: 0,
      marginLeft: 7,
      marginRight: 32
    },
    selectRoot: {
      marginLeft: 0,
      marginRight: 0
    },
    select: {
      paddingRight: 20
    }
  }
};

export default overrides;
